import { Observable } from 'rxjs/Rx'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { GlobalState } from './state'
import { StateLogsParams, getStateLogsByDelivery } from 'store/services/logs'
import { Log } from 'interfaces/logs'

export type LogStep = 'start' | 'finish'
export type LogsState = {
  start: { items: Log[]; isLoading: boolean }
  finish: { items: Log[]; isLoading: boolean }
}

const INITIAL_STATE: LogsState = {
  start: { items: [], isLoading: false },
  finish: { items: [], isLoading: false },
}

type LogsReducer<A = undefined> = (state: LogsState, action?: PayloadAction<A>) => void

const logsSlice = createSlice({
  name: 'logs',
  initialState: INITIAL_STATE,
  reducers: {
    fetchStateLogsByDelivery: ((state, action) => {
      const { step } = action.payload
      state[step].isLoading = true
    }) as LogsReducer<StateLogsParams>,
    fetchStateLogsByDeliverySuccess: ((state, action) => {
      const { items, step } = action.payload
      state[step] = { items, isLoading: false }
    }) as LogsReducer<{ items: Log[]; total: number; step: LogStep }>,
    fetchStateLogsByDeliveryFailure: ((state, action) => {
      const { step } = action.payload
      state[step].isLoading = false
    }) as LogsReducer<{ step: LogStep }>,
  },
})

export const {
  fetchStateLogsByDelivery,
  fetchStateLogsByDeliverySuccess,
  fetchStateLogsByDeliveryFailure,
} = logsSlice.actions

export const reducer = logsSlice.reducer

export const epic = combineEpics(stateLogsRequestEpic)

export function stateLogsRequestEpic(action$) {
  return action$.ofType(fetchStateLogsByDelivery.type).mergeMap((action) => {
    return (
      Observable.ajax(getStateLogsByDelivery(action.payload))
        .mergeMap((res) =>
          Observable.of(
            fetchStateLogsByDeliverySuccess({
              items: res.response['hydra:member'],
              total: res.response['hydra:totalItems'],
              step: action.payload.step,
            }),
          ),
        )
        // @ts-ignore
        .catch((err) => {
          if (typeof err === 'object' && (err.response || {}).code === 401) {
            return Observable.of(authenticationDuck.refreshTokenRequest(action))
          }

          return Observable.of(fetchStateLogsByDeliveryFailure({ step: action.payload.step }))
        })
    )
  })
}

export const selectLogs = (state: GlobalState) => state.logs
